export const pricingCardContainerStyles =
  'h-full bg-base-white dark:bg-gray-dark-900 xl:max-w-[328px] relative flex flex-col items-center justify-end self-end rounded border border-solid border-gray-200 dark: p-4';

export const ctaContainerStyles = 'w-full';
